import { Link } from "react-router-dom";

export const Logo = ({ className = "", size = 34, showText = true }) => {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`flex items-center gap-3 group ${className}`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 transition-transform duration-500 group-hover:rotate-[15deg]"
      >
        <defs>
          <linearGradient id="rexxLogoGrad" x1="0" y1="0" x2="48" y2="48">
            <stop offset="0%" stopColor="#4BE3FF" />
            <stop offset="100%" stopColor="#1E6FFF" />
          </linearGradient>
        </defs>
        {/* Geometric hexagon frame */}
        <path
          d="M24 2 L44 13 V35 L24 46 L4 35 V13 Z"
          stroke="url(#rexxLogoGrad)"
          strokeWidth="2"
          fill="rgba(30,111,255,0.06)"
        />
        {/* Stylized R node-network mark */}
        <path
          d="M17 34 V15 H27 a6 6 0 0 1 0 12 H19 M25 27 L31 34"
          stroke="#4BE3FF"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="17" cy="15" r="2.4" fill="#4BE3FF" />
        <circle cx="31" cy="34" r="2.4" fill="#1E6FFF" />
      </svg>
      {showText && (
        <span className="font-display font-bold text-[1.15rem] tracking-tight text-white leading-none">
          Re<span className="text-[#1E6FFF]">xx</span>engine
        </span>
      )}
    </Link>
  );
};
